"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createExternalReducers = void 0;

var _backbone = _interopRequireDefault(require("backbone"));

var _utils = require("../components/createStore/utils");

var _createExternalReducer = _interopRequireDefault(require("./createExternalReducer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create a number of external state reducers, automatically binding to collection or model events and dispatching
 * RESET_STATE_XXX actions to keep them up to date, allowing external control of a portion of Redux state
 *
 * @param modelCollectionMap
 * @param getStore
 * @return {{externalReducers, unbindExternals: (function(): void)}}
 */
var createExternalReducers = function (modelCollectionMap, getStore) {
  var externalReducers = {};
  var eventBindings = [];
  Object.entries(modelCollectionMap).forEach(function (_ref) {
    var name = _ref[0],
        entity = _ref[1];

    var _createExternalReduce = (0, _createExternalReducer.default)(name),
        reducer = _createExternalReduce.reducer,
        reset = _createExternalReduce.reset;

    externalReducers[name] = reducer;
    var events = entity instanceof _backbone.default.Collection ? _utils.COLLECTION_EVENTS : _utils.MODEL_EVENTS;

    var callback = function () {
      var store = getStore();
      store.dispatch(reset(entity.toJSON()));
    };

    entity.on(events, callback);
    eventBindings.push({
      entity: entity,
      events: events,
      callback: callback
    });
  });
  return {
    externalReducers: externalReducers,
    unbindExternals: function unbindExternals() {
      return eventBindings.forEach(function (_ref2) {
        var entity = _ref2.entity,
            events = _ref2.events,
            callback = _ref2.callback;
        return entity.off(events, callback);
      });
    }
  };
};

exports.createExternalReducers = createExternalReducers;
var _default = createExternalReducers;
exports.default = _default;